import { HotelProduct } from '@/api/Cart/cart.interfaces';
import { Market } from '@shared/config/market/market.models';
import { MainProduct } from '@shared/interfaces/product';
import { ActivityProduct, Coupon } from '@/api/MyBooking/myBooking.interfaces';

export interface GeneralState {
    market: Market;
    prompted: Prompted;
    modal: Modal | null;
    page: Page | null;
    prevPage: Page | null;
}

export interface Prompted {
    baggage: string[];
    baggageGlobal: boolean;
}

export enum ModalType {
    Error = 'error',
    Product = 'product',
    PriceGuarantee = 'priceGuarantee',
    DeleteProduct = 'deleteProduct',
    ProductCancellation = 'productCancellation',
    PassportExamples = 'passportExamples',
    AgentMediation = 'agentMediation',
    SupplierNotes = 'supplierNotes',
    Coupon = 'coupon',
    BaggageWarning = 'baggageWarning',
    DuplicatePaxWarning = 'duplicatePaxWarning',
    TransferConditions = 'transferConditions',
    WelcomeSembonus = 'welcomeSembonus',
    ServicePackage = 'servicePackage',
}

type Modal =
    | ErrorModal
    | ProductModal
    | PriceGuaranteeModal
    | DeleteProductModal
    | ProductCancellationModal
    | PassportExamplesModal
    | AgentMediationModal
    | CouponModal
    | SupplierNotesModal
    | BaggageWarningModal
    | DuplicatePaxWarningModal
    | ServicePackageModal
    | TransferConditionsModal;

interface ErrorModal {
    type: ModalType.Error;
    title?: string;
    message: string;
}

export interface ProductModal {
    type: ModalType.Product;
    productId: string;
    activeTab: ProductModalTab;
}

export enum ProductModalTab {
    Details = 'details',
    Terms = 'terms',
    Price = 'price',
}

export enum TransferModalTab {
    Details = 'details',
    Terms = 'terms',
    Price = 'price',
}

interface PriceGuaranteeModal {
    type: ModalType.PriceGuarantee;
}

interface DeleteProductModal {
    type: ModalType.DeleteProduct;
    products: MainProduct[];
}

interface ProductCancellationModal {
    type: ModalType.ProductCancellation;
    product: HotelProduct | ActivityProduct;
}

interface CouponModal {
    type: ModalType.Coupon;
    coupon: Coupon;
    labels: [];
}

interface PassportExamplesModal {
    type: ModalType.PassportExamples;
}

interface BaggageWarningModal {
    type: ModalType.BaggageWarning;
    onSkip: Function;
}

interface AgentMediationModal {
    type: ModalType.AgentMediation;
}

interface SupplierNotesModal {
    type: ModalType.SupplierNotes;
}

interface DuplicatePaxWarningModal {
    type: ModalType.DuplicatePaxWarning;
}

interface ServicePackageModal {
    type: ModalType.ServicePackage;
}

interface TransferConditionsModal {
    type: ModalType.TransferConditions;
}

export enum Page {
    CheckoutV3 = 'Checkout_v3',
    Payment = 'Payment',
    PostCheckout = 'PostCheckout',
    PreCheckout = 'PreCheckout',
    Booking = 'Booking',
    Bookings = 'Bookings',
    MetaFlight = 'MetaFlight',
    Redirecting = 'Redirecting',
}
